import React from 'react';
import './Component.css';

const Button = (props) =>{
	return(
		<button className="button" onClick={props.test}>
		  <div className="pattern">
		    <div className="target inner bg2"></div>
		  </div>
		  <div className="text">Let's Calculate</div>
		</button>
	);
}

export default Button;